import React from "react";
import { useTranslation } from "react-i18next";
import { MapPinOff } from "lucide-react";
import { Badge } from "../ui/Badge";

/**
 * Marca de "esta dirección no tiene ubicación confirmada".
 *
 * Se usa en los dos listados de pedidos —el del operador y el del comercio—
 * junto a la dirección. No es informativa: mientras esté, el paquete queda
 * fuera de la ruta optimizada, así que es lo que separa un pedido que va a
 * salir a reparto de uno que va a viajar sin parada asignada.
 *
 * Va como componente aparte y no como JSX repetido porque son dos vistas espejo
 * mantenidas por separado, y ya hay antecedentes en este repo de que una se
 * actualice y la otra no.
 */
export default function PendingAddressChip({ className }) {
  const { t } = useTranslation();
  return (
    <Badge
      tone="warning"
      className={className}
      title={t(
        "Sin ubicación confirmada: este pedido no entra a la ruta hasta resolverlo.",
      )}
    >
      <MapPinOff size={12} aria-hidden="true" />
      {t("Dirección por resolver")}
    </Badge>
  );
}
